import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=02b50906&"
import script from "./news1.vue?vue&type=script&lang=js&"
export * from "./news1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports